// MACHINERY V2 (Stroje) — ChromeNavV4 glyph set (M2.1).
//
// Verbatim port of the Ng* icons from design_handoff_machinery_v3/
// machinery-chrome-nav.jsx (14x14 viewBox, currentColor, 1.4 stroke).
// Extracted so ChromeNavV4.tsx and ChromeRightMenus.tsx can share them and
// both stay well under the 300-line rule.
//
// D2 (§9): this nav becomes the PERMANENT platform nav at M2.12, so these
// glyphs outlive the v2 build — they are not throwaway scaffolding.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

const base = {
  width: 14,
  height: 14,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  viewBox: "0 0 14 14",
  "aria-hidden": true,
};

/** Stroje — a machine profile with a spindle head. */
export const NgMachine: React.FC = () => (
  <svg {...base}>
    <path d="M2.5 12 L11.5 12" />
    <path d="M4.5 12 L4.5 9.5 L3 6 L6.5 3.5 L9.5 4.8" />
    <circle cx="10.5" cy="5.2" r="1.5" />
    <path d="M10.5 6.7 L10.5 9 L8.5 12" />
  </svg>
);

/** Service Hub — a wrench. */
export const NgService: React.FC = () => (
  <svg {...base}>
    <path d="M10 1.8 a2.6 2.6 0 0 0 -2.8 3.6 L2.5 10.1 a1.15 1.15 0 1 0 1.6 1.6 L8.8 7 A2.6 2.6 0 0 0 12.2 3.7 L10.5 5.4 L9 5 L8.6 3.5 Z" />
  </svg>
);

/** Sieť partnerov — three linked nodes. */
export const NgNetwork: React.FC = () => (
  <svg {...base}>
    <circle cx="3.5" cy="7" r="1.7" />
    <circle cx="10.5" cy="3.5" r="1.7" />
    <circle cx="10.5" cy="10.5" r="1.7" />
    <path d="M5.1 6.2 L8.9 4.3 M5.1 7.8 L8.9 9.7" />
  </svg>
);

/** Operácie — a board of three columns. */
export const NgOps: React.FC = () => (
  <svg {...base}>
    <rect x="1.5" y="2" width="3.2" height="10" rx="0.8" />
    <rect x="5.9" y="2" width="3.2" height="6.5" rx="0.8" />
    <rect x="10.3" y="2" width="3.2" height="8.5" rx="0.8" />
  </svg>
);

export const NgBell: React.FC = () => (
  <svg {...base}>
    <path d="M7 1.8 a3.6 3.6 0 0 1 3.6 3.6 c0 2.6 0.7 3.4 1.2 3.9 L2.2 9.3 c0.5 -0.5 1.2 -1.3 1.2 -3.9 A3.6 3.6 0 0 1 7 1.8 Z" />
    <path d="M5.8 11.2 a1.3 1.3 0 0 0 2.4 0" />
  </svg>
);

export const NgGear: React.FC = () => (
  <svg {...base}>
    <circle cx="7" cy="7" r="2.1" />
    <path d="M7 1.4 L7 3 M7 11 L7 12.6 M1.4 7 L3 7 M11 7 L12.6 7 M3 3 L4.2 4.2 M9.8 9.8 L11 11 M11 3 L9.8 4.2 M4.2 9.8 L3 11" />
  </svg>
);

export const NgExit: React.FC = () => (
  <svg {...base}>
    <path d="M5.5 2 L2.5 2 L2.5 12 L5.5 12" />
    <path d="M6 7 L12 7 M9.7 4.7 L12 7 L9.7 9.3" />
  </svg>
);
